export default __webpack_public_path__ + "static/media/create-appointment.124d5917.svg";